import { Stack, Typography } from '@mui/material'
import type { ThemeColorEntry } from '../types.js'

type SwatchProps = {
  size?: number
  entry: ThemeColorEntry
}

export function Swatch(props: SwatchProps) {
  const {
    entry: { color, path },
    size = 30,
  } = props

  return (
    <Stack sx={{ alignItems: 'center', flexDirection: 'row', gap: 1, p: 1 }}>
      <div
        style={{
          backgroundColor: color,
          border: '1px solid black',
          borderRadius: '4px',
          height: `${size}px`,
          width: `${size}px`,
        }}
      />
      <Stack>
        <Typography variant="body1">{path}</Typography>
        <Typography variant="caption">{color}</Typography>
      </Stack>
    </Stack>
  )
}
